import { fetcher } from 'src/config/request';
import { ContentEndpoints } from './endpoints';
export const ContentService = {
    async getContent(pageId) {
        return (await fetcher.get(ContentEndpoints.getContent(pageId))).data;
    },
    async createContent(payload) {
        return await fetcher.post(ContentEndpoints.createContent(), payload);
    },
    async publishContent(payload) {
        return await fetcher.put(ContentEndpoints.publishContent(), payload);
    },
    async updateContent(pageId, payload) {
        return await fetcher.put(ContentEndpoints.updateContent(pageId), payload);
    }
};
